import styled from 'styled-components';
import { CardHeader as MUCardHeader } from '@material-ui/core';

const CardHeader = styled(MUCardHeader)`
  background-color: #eee;
`;

export default CardHeader;
